import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-etaupdate-success',
  templateUrl: './etaupdate-success.component.html',
  styleUrls: ['./etaupdate-success.component.css']
})
export class EtaupdateSuccessComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
